/* eslint react-hooks/exhaustive-deps: "warn" */

import { Section } from 'ui/molecules/Section/Section';

import styles from './SectionWhoWeAre.module.scss';

const STATS = [
  { value: '600M+', label: 'Companies' },
  { value: '200+', label: 'Countries' },
  { value: '400+', label: 'Official sources' },
  { value: '2015', label: 'Founded' },
];

export const SectionWhoWeAre = () => (
  <Section>
    <div className={styles.inner}>
      <div className={styles.rail}>
        <span className={styles.eyebrow}>01</span>
        <p className={styles.railTitle}>Who we are</p>
      </div>

      <div className={styles.content}>
        <div className={styles.prose}>
          <p>
            Global Database is a company intelligence platform built to help organisations understand, verify and act on
            businesses worldwide.
          </p>
          <p>
            Since 2015, we have brought together official company records from registries and government sources across
            more than 200 countries, standardising and connecting them into one global data infrastructure covering over
            600 million companies.
          </p>
          <p>
            Our team combines registry expertise, data engineering, financial intelligence and AI to transform
            fragmented records into a clear view of each business — from legal identity and financial performance to
            directors, shareholders, ownership structures and corporate relationships.
          </p>
          <p>
            We are building the trusted data foundation for the next generation of business decisions, giving people,
            applications and AI agents the context they need to understand companies with confidence.
          </p>
        </div>

        <div className={styles.stats}>
          {STATS.map(({ value, label }) => (
            <div key={label} className={styles.statItem}>
              <span className={styles.statValue}>{value}</span>
              <span className={styles.statLabel}>{label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </Section>
);
